import { Injectable } from "@angular/core";
import { AttachedFile } from "../domain/attachedFile";
import { DocumentService } from "../services/document.service";

@Injectable()
export class FileUtility {

    constructor(

        private documentService: DocumentService) { }

    ViewDocument(file: AttachedFile) {
        this.documentService.getDocument(file).subscribe((x: any) => {

                const url = window.URL.createObjectURL(x.body);
                const a = document.createElement('a');

                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                /* const matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
                 if (matches != null && matches[1]) {
                   a.download = matches[1].replace(/['"]/g, '');
                
                 }*/
                a.target = '_blank';
                a.href = url;

                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox

                a.click();
                a.remove();
            });
    }

    DownLoadDocument(file: AttachedFile) {
        this.documentService.getDocument(file)
            .subscribe((x: any) => {

                const url = window.URL.createObjectURL(x.body);
                const a = document.createElement('a');

                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
                if (matches != null && matches[1]) {
                    a.download = matches[1].replace(/['"]/g, '');

                }
                a.target = '_blank';
                a.href = url;

                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox

                a.click();
                a.remove();
            });
    }
}
